export default __webpack_public_path__ + "static/media/app-store.b65445aa.svg";